import { Box, Typography } from '@mui/material';

function MaxValueExceededWarning({ warningText }: { warningText: string }) {
  return (
    <Box
      style={{
        minWidth: '500px',
        maxWidth: '500px',
      }}
    >
      <Typography variant='subtitle3' color='error'>
        {warningText}
      </Typography>
    </Box>
  );
}

export default MaxValueExceededWarning;
